import { render } from "./BotAnalytics.vue?vue&type=template&id=703cb327&scoped=true"
import script from "./BotAnalytics.vue?vue&type=script&lang=js"
export * from "./BotAnalytics.vue?vue&type=script&lang=js"

import "./BotAnalytics.vue?vue&type=style&index=0&id=703cb327&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703cb327"]])

export default __exports__